<h1>
  Simple Serialized NgRx Router Store
</h1>
<div class="shields">
  <a
    href="https://github.com/SachinShekhar/ss-ngrx-router-store/actions?query=workflow%3ABuild"
  >
    <img
      src="https://github.com/SachinShekhar/ss-ngrx-router-store/workflows/Build/badge.svg"
      alt="Build"
    />
  </a>
  <a href="https://github.com/SachinShekhar/ss-ngrx-router-store">
    <img
      alt="GitHub last commit"
      src="https://img.shields.io/github/last-commit/SachinShekhar/ss-ngrx-router-store?logo=github"
    />
  </a>
  <a href="https://www.npmjs.com/package/ss-ngrx-router-store">
    <img
      alt="npm (tag)"
      src="https://img.shields.io/npm/v/ss-ngrx-router-store/latest?logo=npm"
    />
  </a>
  <a href="https://www.npmjs.com/package/ss-ngrx-router-store">
    <img
      alt="npm bundle size"
      src="https://img.shields.io/bundlephobia/minzip/ss-ngrx-router-store?label=npm%20-%20minzipped&logo=npm"
    />
  </a>
  <a
    href="https://github.com/SachinShekhar/ss-ngrx-router-store/blob/master/LICENSE"
  >
    <img
      alt="NPM License"
      src="https://img.shields.io/npm/l/ss-ngrx-router-store"
    />
  </a>
</div>
<router-outlet></router-outlet>
